import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@crm/shared/lib';
import { TableCell } from '@crm/shared/ui/Table';

type DealTableCellProps = ComponentProps<typeof TableCell> & {
    isEmpty?: boolean;
    fallback?: ReactNode;
};

export const DealTableCell = ({
    children,
    className,
    isEmpty = false,
    fallback = null,
    ...props
}: DealTableCellProps) => (
    <TableCell className={cn('overflow-hidden text-xs text-gray-800', className)} {...props}>
        {isEmpty ? fallback : children}
    </TableCell>
);
